import React from 'react';
import styled from 'styled-components';

const AvatarContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #008080;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1rem;
  font-family: 'Roboto', sans-serif;
`;

const Avatar = ({ name }) => {
  const initials = name
    .split(' ')
    .map(word => word.charAt(0).toUpperCase())
    .join('');

  return <AvatarContainer>{initials}</AvatarContainer>;
};

export default Avatar;